var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 66.572,
    height: 82.308,
    fill: "#1d254f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-user-location-marker",
    transform: "translate(-796 -3259.578)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 100,
    cy: 100,
    r: 100,
    transform: "translate(796 3259.578)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(846.057 3334.83) rotate(-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M.327,75.79,29.569,2.668a4.244,4.244,0,0,1,7.894.033l28.8,73.793A4.244,4.244,0,0,1,59.37,81.1L36.151,58.851a4.244,4.244,0,0,0-5.835-.036L7.166,80.465A4.244,4.244,0,0,1,.327,75.79",
    transform: "translate(0 0)",
    fill: "#1d254f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLocationMarker);
export default __webpack_public_path__ + "static/media/icon-user-location-marker.43349b894e7e0d1ace2348760c581f34.svg";
export { ForwardRef as ReactComponent };